import React, { useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import { MapPin, Calendar, Users, Sparkles } from 'lucide-react';
export const EventDetailsSection = () => {
  const sectionRef = useRef<HTMLElement>(null);
  const {
    scrollYProgress
  } = useScroll({
    target: sectionRef,
    offset: ['start end', 'end start']
  });
  const opacity = useTransform(scrollYProgress, [0, 0.2, 0.8, 1], [0, 1, 1, 0]);
  return <motion.section id="details" ref={sectionRef} className="py-20 md:py-28 bg-black relative overflow-hidden" style={{
    opacity
  }} data-id="element-1184" data-mp="3cpzq8f8emerz">
      <div className="absolute inset-0 bg-gradient-to-b from-amber-950/10 to-black/60 z-0" data-id="element-1185" data-mp="3ls90r53oa85d"></div>
      <div className="container mx-auto px-4 relative z-10" data-id="element-1186" data-mp="3qqitl91xcwnt">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center mb-24" data-id="element-1187" data-mp="1rd6f5ihqva7q">
          <p className="text-amber-400/60 tracking-[0.3em] text-xs uppercase mb-6" data-id="element-1188" data-mp="tkxksjitsgzj">
            Essential Information
          </p>
          <h2 className="font-serif text-5xl md:text-7xl text-white mb-8" data-id="element-1189" data-mp="pi19ldvm7n5m">
            EVENT
            <br data-id="element-1190" data-mp="kiy1tlo932ty" />
            <span className="text-amber-400" data-id="element-1191" data-mp="1hbbdmc98ijv6">DETAILS</span>
          </h2>
          <div className="w-24 h-px bg-amber-400/30 mx-auto" data-id="element-1192" data-mp="1haienxgioynl"></div>
        </motion.div>
        <div className="max-w-6xl mx-auto" data-id="element-1193" data-mp="1da7zpvaqyxwl">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-16" data-id="element-1194" data-mp="18an1xo7bcvlg">
            {/* Venue Card */}
            <motion.div initial={{
            opacity: 0,
            x: -30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.8
          }} data-id="element-1195" data-mp="13biogldcwbpb">
              <div className="relative" data-id="element-1196" data-mp="3pgtyydwv32uo">
                <div className="aspect-video relative overflow-hidden mb-8 rounded-lg" data-id="element-1197" data-mp="3uijb5wvtlmkc">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/kppHXez1XGBnRYW5bwUDVX/illumiarium.png" alt="Illuminarium Venue" className="w-full h-full object-contain bg-black" data-id="element-1198" data-mp="3giiaoijgwh5e" />
                </div>
                <div className="space-y-8" data-id="element-1199" data-mp="3bivp9lthjuli">
                  <div className="flex items-start" data-id="element-1200" data-mp="3bjx9ogwe5tfw">
                    <MapPin className="w-6 h-6 text-amber-400 mr-4 flex-shrink-0 mt-1" data-id="element-1201" data-mp="2xs0n0sdhsbqw" />
                    <div data-id="element-1202" data-mp="31tc58cu1dup2">
                      <h4 className="font-serif text-2xl text-amber-400 mb-3" data-id="element-1203" data-mp="31skkxy5w3je3">
                        Venue
                      </h4>
                      <p className="text-white/80 font-light leading-relaxed" data-id="element-1204" data-mp="2nu2y02nt6ax8">
                        Illuminarium Toronto
                        <br data-id="element-1205" data-mp="2suiayt46hgeo" />
                        123 Experience Drive
                        <br data-id="element-1206" data-mp="2974c0n7q08pw" />
                        Toronto, ON M5V 2K4
                      </p>
                    </div>
                  </div>
                  <div className="flex items-start" data-id="element-1207" data-mp="2j4s4f6hut44w">
                    <Calendar className="w-6 h-6 text-amber-400 mr-4 flex-shrink-0 mt-1" data-id="element-1208" data-mp="2j6d234zgt36z" />
                    <div data-id="element-1209" data-mp="2e4dzhxbjuab3">
                      <h4 className="font-serif text-2xl text-amber-400 mb-3" data-id="element-1210" data-mp="2e8bkkohotbxm">
                        Dates
                      </h4>
                      <p className="text-white/80 font-light leading-relaxed" data-id="element-1211" data-mp="2n7f41tkrntcn">
                        Summer 2026
                        <br data-id="element-1212" data-mp="31ui15z56fzzg" />
                        Doors open at 6:00 PM
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </motion.div>
            {/* Details Card */}
            <motion.div initial={{
            opacity: 0,
            x: 30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.8
          }} className="flex flex-col justify-between space-y-8" data-id="element-1213" data-mp="3atvamrtawok6">
              <div className="space-y-8" data-id="element-1214" data-mp="1ix4zd45qel7g">
                <div className="flex items-start" data-id="element-1215" data-mp="1iyy76ms2zbh1">
                  <Users className="w-6 h-6 text-amber-400 mr-4 flex-shrink-0 mt-1" data-id="element-1216" data-mp="l9wjbooi24cu" />
                  <div data-id="element-1217" data-mp="q7o9oe9hxiex">
                    <h4 className="font-serif text-2xl text-amber-400 mb-3" data-id="element-1218" data-mp="q993u2rwezc9">
                      Capacity
                    </h4>
                    <p className="text-white/80 font-light leading-relaxed" data-id="element-1219" data-mp="v9dn20k6y866">
                      Limited & exclusive seating
                      <br data-id="element-1220" data-mp="26mg0wnuwojmn" />
                      Only 120 guests per evening
                    </p>
                  </div>
                </div>
                <div className="flex items-start" data-id="element-1221" data-mp="2amq7a1mm1c21">
                  <Sparkles className="w-6 h-6 text-amber-400 mr-4 flex-shrink-0 mt-1" data-id="element-1222" data-mp="3v62c0smqz6zp" />
                  <div className="flex-1" data-id="element-1223" data-mp="3v7ws9tn2qaxg">
                    <h4 className="font-serif text-2xl text-amber-400 mb-3" data-id="element-1224" data-mp="3r5jjsxgxzywz">
                      Format
                    </h4>
                    <div className="relative bg-gradient-to-br from-amber-400/10 to-amber-400/5 border-l-2 border-amber-400 p-5 rounded-r-lg" data-id="element-1225" data-mp="3mbxj83o1zlhj">
                      <span className="inline-block text-[10px] tracking-[0.25em] uppercase text-amber-400 font-medium mb-3 px-2 py-1 bg-amber-400/10 border border-amber-400/30 rounded" data-id="element-1226" data-mp="3cg3vrp8sq7kz">
                        Walk-Through Cinematic Journey
                      </span>
                      <p className="text-white font-light leading-relaxed mb-3" data-id="element-1227" data-mp="33gqw1oah4xdg">
                        Step into the court of{' '}
                        <span className="text-amber-400 font-medium" data-id="element-1228" data-mp="11o2ox3uplpse">
                          Maharaja Ranjit Singh
                        </span>
                        . A 60-minute immersive walk through the lost world of
                        the Sikh Empire — brought alive through cinematic
                        visuals, live performance, and interactive moments.
                      </p>
                      <p className="text-white/60 text-sm font-light italic" data-id="element-1229" data-mp="16t668f7ygbds">
                        Think Universal Studios meets the Wizarding World — but
                        rooted in the heritage of Punjab.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="border border-amber-400/30 p-8 bg-black/40" data-id="element-1230" data-mp="23i42y2z9mjdl">
                <h3 className="font-serif text-3xl text-amber-400 mb-4" data-id="element-1231" data-mp="1pjnzckwp98zo">
                  Summer 2026
                </h3>
                <p className="text-white/70 font-light mb-4 leading-relaxed" data-id="element-1232" data-mp="1uged31l17shx">
                  The exclusive experience takes place Summer 2026. All ticket
                  holders receive admission to this premiere experience.
                </p>
                <div className="w-full h-px bg-white/10 my-6" data-id="element-1233" data-mp="bj1ba6ll6dpx"></div>
                <h4 className="text-xl text-amber-400 font-light mb-3" data-id="element-1234" data-mp="bldzh1hxtkbf">
                  Monthly Experiences
                </h4>
                <p className="text-white/70 font-light mb-6 leading-relaxed" data-id="element-1235" data-mp="kjpncvrf6406">
                  Your ticket also grants access to one monthly experience
                  between May and December 2026. Choose your preferred date when
                  finalizing your reservation.
                </p>
                <div className="flex justify-between items-center pt-4 border-t border-white/10" data-id="element-1236" data-mp="3jzcsbu9m4pkp">
                  <span className="text-amber-400 font-light tracking-wider" data-id="element-1237" data-mp="1ktxtxqiadso">
                    Summer 2026
                  </span>
                  <span className="text-white/60 text-sm tracking-wider uppercase" data-id="element-1238" data-mp="3syznhybr0z5b">
                    Premiere Event
                  </span>
                </div>
                <div className="flex justify-between items-center pt-3" data-id="element-1239" data-mp="30bnb2gzay7pq">
                  <span className="text-amber-400 font-light tracking-wider" data-id="element-1240" data-mp="3099g084mgvi6">
                    May - Dec 2026
                  </span>
                  <span className="text-white/60 text-sm tracking-wider uppercase" data-id="element-1241" data-mp="2jq3u7zbmaee4">
                    Monthly Access
                  </span>
                </div>
              </div>
            </motion.div>
          </div>
        </div>
        {/* Bottom Quote */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        delay: 0.3
      }} className="text-center mt-24" data-id="element-1242" data-mp="2yo4kacptdw0c">
          <p className="text-xl text-white/70 italic font-light max-w-3xl mx-auto" data-id="element-1243" data-mp="3cerh1zc0lbts">
            "Step inside a kingdom reborn — where history, sense, and story
            collide for one unforgettable evening."
          </p>
        </motion.div>
      </div>
    </motion.section>;
};